import { Pipe, PipeTransform } from '@angular/core';
import { LicenseUser } from '@portal-core/license-users/models/license-user.model';
import { LicenseUsersService } from '@portal-core/license-users/services/license-users.service';
import { Observable, of } from 'rxjs';

@Pipe({
  name: 'mcLicenseUserAsync'
})
export class LicenseUserAsyncPipe implements PipeTransform {
  constructor(private licenseUsersService: LicenseUsersService) { }

  transform(
    licenseUserId: number | null | undefined,
    allowApiRequest: boolean = false
  ): Observable<LicenseUser | null> {
    if (!licenseUserId) {
      return of(null);
    }

    return this.licenseUsersService.getItemById$(licenseUserId, {
      allowApiRequest
    });
  }
}
